import { render, staticRenderFns } from "./download-action.vue?vue&type=template&id=584c42e3&scoped=true"
import script from "./download-action.vue?vue&type=script&lang=js"
export * from "./download-action.vue?vue&type=script&lang=js"
import style0 from "./download-action.vue?vue&type=style&index=0&id=584c42e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c42e3",
  null
  
)

export default component.exports